export default {
  setErrorAba: (state, _payload) => {
    return (state.abas[_payload.abaId].temError = _payload.temError);
  },
  setMostrarErrors: (state, _boo) => (state.mostrarErrors = _boo)
};
